<template>
  <div class="auth-loading">
    <p>正在登录中...</p>
  </div>
</template>

<script>
export default {
  mounted() {
    // 此页面不需要内容，路由守卫会处理所有逻辑
  }
}
</script>